const featureToggles = {
  disableSignIn: true,
  disableMyProjects: true,
  disableMyProposals: true,
}

export default featureToggles

